import type { RouteLocationNormalizedLoaded } from 'vue-router'

/**
 * Which page instance an address belongs to (EXP-1616).
 *
 * The editor is one page per motif: `/motifs/A` and `/motifs/B` are two pages, and the step
 * from one to the other ends the first and builds the second, exactly as the way through the
 * gallery does. Vue Router keeps the instance when only the parameter of the same route
 * changes, and the page then went on showing A under the address of B (spec, Ausgangslage).
 *
 * Every other address gets no key and keeps the behaviour it had: the gallery writes its
 * filters into the query, the settings swap their tab in a nested view, and neither is
 * rebuilt for it. Query and hash are not part of the key, so neither rebuilds the editor.
 */
export function pageKey(route: Pick<RouteLocationNormalizedLoaded, 'name' | 'params'>): string | undefined {
  if (route.name !== 'motif-authoring') return undefined
  return `motif-authoring:${String(route.params.code ?? '')}`
}
